<template>
  <div>
    <div class="formBox margbot" ref="searchBox">
      <el-form :inline="true" class="demo-form-inline" label-width="90px" size="mini">
        <!-- <div class="searchBox inpBox"> -->
        <div class="formItemBox">
          <el-form-item label="所在仓库:" prop="organizationId">
            <el-select v-model="searchFrom.organizationId" placeholder="">
              <el-option v-for="val in warehouseList" :label="val.relTenantName" :value="val.relTenantCode"
                :key="val.relTenantCode"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="货物类型:" prop="productType">
            <el-select v-model="searchFrom.productType" placeholder="请选择">
              <el-option v-for="item in productTypes" :label="item.show_name" :value="item.item_no"
                :key="item.item_no"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="货权方:" prop="ownerCustomerName" v-if="tableArr[1]">
            <el-input placeholder="" v-model="searchFrom.ownerCustomerName"></el-input>
          </el-form-item>
          <el-form-item label="控货方:" prop="primaryCustomerName" v-if="tableArr[0]">
            <el-input placeholder="" v-model="searchFrom.primaryCustomerName"></el-input>
          </el-form-item>
          <el-form-item label="客户名称:" prop="customerName">
            <el-input placeholder="" v-model="searchFrom.customerName"></el-input>
          </el-form-item>
          <el-form-item label="出库单号:" prop="outstockNo">
            <el-input placeholder="" v-model="searchFrom.outstockNo"></el-input>
          </el-form-item>
          <el-form-item label="外部单号:" prop="outBillNo">
            <el-input placeholder="" v-model="searchFrom.outBillNo"></el-input>
          </el-form-item>
          <el-form-item label="产地:" prop="steelMillName">
            <el-input placeholder="" v-model="searchFrom.steelMillName"></el-input>
          </el-form-item>
          <el-form-item label="规格:" prop="specification">
            <el-input placeholder="" v-model="searchFrom.specification"></el-input>
          </el-form-item>
          <el-form-item label="材质:" prop="model">
            <el-input placeholder="" v-model="searchFrom.model"></el-input>
          </el-form-item>
          <el-form-item label="出库车号:" prop="outstockPlateNumber">
            <el-input placeholder="" v-model="searchFrom.outstockPlateNumber"></el-input>
          </el-form-item>
          <el-form-item label="出库司机:" prop="driverName">
            <el-input placeholder="" v-model="searchFrom.driverName"></el-input>
          </el-form-item>
          <el-form-item label="出库时间:" prop="createTime">
            <el-date-picker v-model="timecheacked" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
              type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </el-form-item>
        </div>
        <!-- </div> -->
        <div class="searchBtnBox">
          <el-form-item>
            <el-button type="primary" @click="searchFn">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="resetForm('searchFrom')">重置</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="exportFn" :disabled="isDisable">导出</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="dayin" btnCode='00UM010200' v-if="btnFlg[0]">打印</el-button>
          </el-form-item>
          <el-form-item>
            <p class="margin0">总件数：<span class="red">{{ tongji.totalNumber }}</span>件</p>
          </el-form-item>
          <el-form-item>
            <p class="margin0">总重量：<span class="red">{{ tongji.totalAllWeight }}</span>吨</p>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{ height: h }">
      <el-table :data="tableList" ref="table" bordersize="mini" @row-click="handleRowClick" style="width: 100%"
        height="100%" :header-cell-style="{ background: '#F5F5F5', color: 'black' }" highlight-current-row center border
        v-if="tableArr.length > 0">
        <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
        <el-table-column align="center" label="操作" width="160" v-if="this.isjianfa">
          <template slot-scope="scope">
            <el-button type="text" @click="lookBD(scope.row)" size="mini"
              v-if="Number(scope.row.weighingWeight / 1) > 0">磅单</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="billCreateTime" label="提单时间" width="180" :formatter="emptyFn"></el-table-column>
        <el-table-column prop="outstockNo" width="220" :formatter="emptyFn" label="出库单号"></el-table-column>
        <el-table-column prop="billNo" width="150" :formatter="emptyFn" label="提货单号"></el-table-column>
        <el-table-column prop="outBillNo" width="150" :formatter="emptyFn" label="外部单号"></el-table-column>
        <el-table-column prop="outstockDate" min-width="200" :formatter="dateTimeFormat" label="出库时间"></el-table-column>
        <el-table-column prop="ownerCustomerName" min-width="200" v-if="tableArr[1]" :formatter="emptyFn"
          label="货权方"></el-table-column>
        <el-table-column prop="primaryCustomerName" min-width="200" v-if="tableArr[0]" :formatter="emptyFn"
          label="控货方"></el-table-column>
        <el-table-column prop="customerName" min-width="200" :formatter="emptyFn" label="客户名称"></el-table-column>
        <el-table-column prop="productTypeName" min-width="150" :formatter="emptyFn" label="货物类型"></el-table-column>
        <el-table-column prop="placeOfOrigin" width="150" :formatter="emptyFn" label="产地"></el-table-column>
        <el-table-column prop="specification" min-width="150" :formatter="emptyFn" label="规格"></el-table-column>
        <el-table-column prop="model" min-width="150" :formatter="emptyFn" label="材质"></el-table-column>
        <!-- <el-table-column prop="root"  width="150" :formatter="emptyFn" label="单件支数"></el-table-column>
        <el-table-column prop="length"  min-width="150" :formatter="emptyFn" label="长度(m)"></el-table-column> -->
        <el-table-column prop="number" min-width="120" :formatter="emptyFn" label="出库件数"></el-table-column>
        <el-table-column prop="allWeight" width="150" label="出库重量(吨)"></el-table-column>
        <el-table-column prop="weight" min-width="150" label="出库理重(吨)"></el-table-column>
        <el-table-column prop="weighingWeight" width="150" label="出库磅重(吨)"></el-table-column>
        <!-- <el-table-column prop="primaryCustomerName"  min-width="250" :formatter="emptyFn" label="控货方"></el-table-column> -->
        <el-table-column prop="outstockPlateNumber" min-width="120" :formatter="emptyFn" label="出库车号"></el-table-column>
        <el-table-column prop="driverName" min-width="120" :formatter="emptyFn" label="出库司机"></el-table-column>
        <el-table-column prop="telephone" min-width="150" :formatter="emptyFn" label="司机电话"></el-table-column>
        <el-table-column prop="organizationName" width="150" :formatter="emptyFn" label="所在仓库"></el-table-column>
        <el-table-column prop="plateNumber" min-width="120" :formatter="emptyFn" label="车船号"></el-table-column>
        <el-table-column prop="shipForecastNo" min-width="170" :formatter="emptyFn" label="预报编号"></el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div>
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo" :page-sizes="[50, 100, 200, 1000]" :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </div>
    <el-dialog title="查看磅单" center :visible.sync="BDVisible" width='50%' :close-on-click-modal="false"
      :close-on-press-escape="false">
      <div class="demo-image__preview">
        <div>
          <span v-for="(item, index) in imgList" :key="index">
            <el-image :preview-src-list="getSrcList(index, imgList)" fit="cover" :src="item"
              style="width:200px;height:180px;margin:0 20px 20px;">
            </el-image>
          </span>
          <span v-if="imgList.length == 0">暂无信息</span>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="BDVisible = false" type="primary">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getBtn, getAttribute, getAttributeA } from '@/utils/getButton'
import { emptyFn, dateTimeFormat, dateFormat } from '@/utils/util'
import { getOutStockThreadList, getOutStockThreadWN, selectCommonDictionary, getImgShow, getOrganizationNameList } from '@/api/soc-stock-cosco'
import { exportExcel } from '@/utils/fileDown.js'

export default {
  props: {
    productTypes: {
      type: Array,
      required: true
    },
    warehouseList: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      isjianfa: false,
      BDVisible: false,
      outstockSummaryId: '',
      row: [],
      imgList: [],
      tableArr: [],
      // 按钮
      btnFlg: [],
      btnIdArr: ['00UM010200'],
      h: 500,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      emptyFn: emptyFn,
      dialogVisible: false,
      tableList: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      total: 0,
      loading: 'false',
      goodTypes: [],
      tongji: {},
      isDisable: false,
      timecheacked: '',
      oneCustomerTaxId: localStorage.getItem('tenantTaxpayerNumber')
    }
  },
  created () {
    this.searchFrom.oneOrTwoCustomerTaxId = this.oneCustomerTaxId
    this.btnFlg = getBtn(this.btnIdArr, '/ZYgoodsRecord')
    this.tableArr = getAttribute('ARRoneCustomerName,ARRownerCustomerName')
    if (this.warehouseList.length > 0) {
      this.$set(this.searchFrom, 'organizationId', this.warehouseList[0].relTenantCode)
    }
    this.getList()
    if (localStorage.getItem('isCutCrm3') == 1) {
      getAttributeA('ARRisSelfWarehouse', this.warehouseList[0].relTenantCode).then(res => {
        console.log(res)
        if (res[0] == 3) { // 是建发库
          this.isjianfa = true
        }
        this.getList(this.searchFrom)
      })
    } else {
      getOrganizationNameList({
        userCode: localStorage.getItem('userCode'),
        tenantCode: localStorage.getItem('tenantCode')
      }).then(res => {
        this.warehouseList = res
        if (res.length > 0) {
          // this.$set(this.searchFrom, 'organizationId', this.warehouseList[0].relTenantCode)
          let orgName = this.warehouseList[0].relTenantName
          if (orgName.indexOf('建发钢铁物流') != -1 || orgName.indexOf('首线联合') != -1 || orgName.indexOf('建发') != -1) {
            this.isjianfa = true
          }
        }
        this.getList(this.searchFrom)
      })
    }
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 215) + 'px'
  },
  methods: {
    dayin () {
      if (this.tableList.length == 0) {
        this.$message({
          message: '暂无数据',
          type: 'error'
        })
        return
      }
      if (this.row.length == 0) {
        this.$message({
          message: '请选择一条数据进行操作',
          type: 'error'
        })
        return
      }

      this.$router.push({ // 核心语句
        path: '/DYchukuDan', // 跳转的路径
        query: {
          // 路由传参时push和query搭配使用 ，作用时传递参数
          id: this.row[0].outstockId,
          jfFlag: this.isjianfa ? 1 : 2// 1为建发
        }
      })
    },
    // 磅单
    lookBD (row) {
      this.BDVisible = true
      this.outstockSummaryId = row.outstockSummaryId
      this.getInfos()
      this.imgList = []
    },
    // 点击凭证放大
    getSrcList (index, arr) {
      return arr.slice(index).concat(arr.slice(0, index))
    },
    getInfos () {
      const that = this
      getImgShow({
        businessId: that.outstockSummaryId,
        businessType: 'out_stock_weight_image'
      })
        .then(res => {
          // console.log(res)
          if (res.length != 0) {
            that.imgList.push(res[0].url)
          }
        })
        .catch(err => {
          this.$message({ message: err.message, type: 'error' })
        })
    },
    // 导出
    exportFn () {
      let falg = this.tableArr[0]
      let form = { ...this.searchFrom }
      form.primaryCustomerNameFlag = falg
      form.ownerCustomerNameFlag = this.tableArr[1]
      delete form.pageNo
      delete form.pageSize
      exportExcel(
        this.global.wmsCenter + '/wmsApi/exportOutStockThreadList',
        form,
        '出库记录'
      )
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    },
    searchFn () {
      if (this.timecheacked) {
        this.searchFrom.outstockDateStart = this.timecheacked[0]
        this.searchFrom.outstockDateEnd = this.timecheacked[1]
      } else {
        this.searchFrom.outstockDateStart = null
        this.searchFrom.outstockDateEnd = null
      }
      this.getList()
    },
    // 选择数据

    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
      this.row = []
      this.row.push(row)
    },
    // 获取列表
    getList () {
      this.loading = true
      getOutStockThreadList(this.searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
        this.row = []
        setTimeout(() => {
          if (this.tableList.length !== 0) {
            this.$refs.table.setCurrentRow(this.tableList[0], true)
            this.row.push(this.tableList[0])
          }
        }, 10)
      })
      getOutStockThreadWN(this.searchFrom).then(res => {
        this.tongji = res
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList()
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList()
    },
    // 重置
    resetForm (formName) {
      // debugger
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        oneOrTwoCustomerTaxId: this.oneCustomerTaxId,
        organizationId: this.warehouseList[0].relTenantCode
      }
      this.timecheacked = null
    },

    closeDialog () {
      this.addFrom = {}
      this.$refs.table.clearSelection()
      this.$refs.addFrom.clearValidate()
      this.flag = false
    }
  }
}
</script>

<style scoped lang='less'>
.searchBtnBox {
  margin-left: 10px;
}

.inpBox .el-date-editor {
  width: 350px !important;
}

.imgBox {
  display: flex;

  .item {
    display: flex;
    width: 50%;
    justify-content: space-around;
  }
}

/deep/ .checkboxBox {
  display: flex;

  label {
    flex-shrink: 0;
  }

  .el-checkbox-group {
    width: 250px;
  }
}
</style>
